import api from "../../services/api";

const assertActive = (signal) => {
  if (signal?.aborted) {
    const error = new Error("Carregamento cancelado.");
    error.name = "AbortError";
    throw error;
  }
};

// The API remains paginated even when the operator chooses "Todas".
export async function loadPublicationPhotos({
  eventId, queue, sort, search, page = 1, pageSize = 50, signal, onProgress,
}) {
  const all = pageSize === "all";
  const limit = all ? 100 : Number(pageSize);
  let currentPage = all ? 1 : page;
  const collected = new Map();
  while (true) {
    assertActive(signal);
    const response = await api.get(`/publication/events/${eventId}/photos`, {
      params: { queue, sort, ...(search ? { search } : {}), page: currentPage, limit },
      signal,
    });
    assertActive(signal);
    const batch = response.data?.photos || [];
    const total = Number(response.data?.pagination?.total ?? batch.length);
    const totalPages = Math.max(1, Math.ceil(total / limit));
    if (!all) {
      if (currentPage > totalPages) {
        currentPage = totalPages;
        continue;
      }
      return { photos: batch, pagination: { page: currentPage, limit, total, totalPages } };
    }
    const previousCount = collected.size;
    batch.forEach((photo) => collected.set(photo.id, photo));
    const photos = Array.from(collected.values());
    onProgress?.({ photos, loaded: photos.length, total });
    if (currentPage >= totalPages) {
      if (photos.length !== total) {
        throw new Error("A fila mudou durante o carregamento. Atualize para obter a lista completa.");
      }
      return { photos, pagination: { page: 1, limit: 100, total, totalPages: 1 } };
    }
    if (collected.size === previousCount) {
      throw new Error("O carregamento não avançou. Atualize a fila para tentar novamente.");
    }
    currentPage += 1;
  }
}
